export class PhraseDetailsCache {

  private static MAX_KEYS_SIZE = 300;
  private static MAX_KEY_LEN = 300;
  private static cache: Map<string, string> = new Map<string, string>();

  public static put(params: string[], result: string): boolean {
    if (PhraseDetailsCache.cache.size > this.MAX_KEYS_SIZE) {
      PhraseDetailsCache.cache.clear();
    }
    const key = PhraseDetailsCache.getKey(params);
    if (key.length > this.MAX_KEY_LEN) return false;
    PhraseDetailsCache.cache.set(key, result);
    return true;
  }

  public static get(params: string[]): string | undefined {
    const key = PhraseDetailsCache.getKey(params);
    return PhraseDetailsCache.cache.get(key);
  }

  private static getKey(params: string[]): string {
    return params.join('|');
  }
}